import styled from "@emotion/styled";
import {  Form, Input } from "antd";
import React, { FC } from "react";

interface ProductNameFormProps {
  is_active: boolean;
}

const ProductNameForm: FC<ProductNameFormProps> = ({ is_active }) => {
  return (
    <FormWrapper>
      <Form.Item
        label="ชื่อสินค้า"
        name="name"
        required
        rules={[{ required: is_active, message: "กรุณากรอกชื่อสินค้า" }, {
          validator: async (rule, value) => {
           // ถ้าไม่มีค่าให้ผ่าน (ให้ required validation จัดการ)
           if (!value || value.trim() === '') {
             return Promise.resolve();
           }
           
           //remove emojis and symbols
           const cleanedValue = value.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[\u2600-\u27FF]|[\u2300-\u23FF]|[\u2000-\u206F]|[\u2190-\u21FF]/g, "");
           if (cleanedValue !== value) {
            throw new Error('ไม่อนุญาตให้มีอักษรพิเศษ');
           }
          }
        }]}
      >
        <Input
          placeholder="กรุณากรอกชื่อสินค้า"
          showCount
          maxLength={55}
          size="small"
          type="text"
        />
      </Form.Item>
    </FormWrapper>
  );
};

export default ProductNameForm;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 2px 20px;
  margin-bottom: 10px;
  border-radius: 8px;
`;
